(ns dre.widgets.authors.views
  (:require
   [dre.components.icon :refer [fa-icon svg]]
   [dre.i18n.events :as-alias i18n]
   [dre.i18n.views :refer [tr]]
   [dre.components.inputs :refer [input-search]]
   [dre.components.widget.views :as widget-base]
   [dre.components.widget.views.common :refer [no-result title-with-filter]]
   [dre.components.widget.views.table-list :refer [table-list]]
   [dre.components.force-directed-graph :refer [force-directed-graph]]
   [dre.components.tooltip :refer [tooltip-wrapper]]
   [dre.page-util :refer [round nbsp debounce2]]
   [dre.utils :refer [restricted-role?]]
   [dre.utils.bem :as bem]
   [dre.app.events :as app-events]
   [dre.widgets.authors.events :as events]
   [dre.components.widget.db :as wdb]
   [dre.components.widget.events :as wevents]
   [dre.pages.search.events :as search-events]
   [re-frame.core :as rf]))

(defn widget-header
  [done? state]
  (let [author-input-text @(rf/subscribe [::events/author-input-text])
        last-selected-filter-key @(rf/subscribe [::search-events/last-selected-filter-key])
        widget-filters @(rf/subscribe [::search-events/widget-filters])
        filter (get widget-filters events/id)]
    [:div {:class :widget-header-search}
     (when (and (not done?) (= :success state))
       [:div [tr " Partial results shown due to network problem, try refreshing page"]])
     [input-search {:placeholder @(rf/subscribe [::i18n/translate "Search for author by name"])
                    :type :search
                    :value author-input-text
                    :on-change (fn [e]
                                 (if (instance? js/InputEvent (-> e .-nativeEvent))
                                   (rf/dispatch [::events/set-author-input-text (-> e .-target .-value) false])
                                   (rf/dispatch [::events/set-author-input-text (-> e .-target .-value) true]))
                                 false)
                    :on-search (fn [e] 
                                 (rf/dispatch [::events/search-author]))
                    }]]))

(defn widget-content
  [_id _data _data-graph _selected-tab]
  (fn [id data data-graph selected-tab]
    (let [widget-filters @(rf/subscribe [::search-events/widget-filters])
          filter (get widget-filters events/id)
          selected-nodes (set (map :index filter))
          title-fn (fn [row]
                     (str (:label row) " (" (round (:score row)) "%)"))
          node-click-fn (fn [event d]
                          (let [d (js->clj d)
                                author (get d "author")
                                name (get d "name")
                                pill (events/->pill-with-index author name (get d "index"))]
                            (rf/dispatch [::search-events/widget-filter-select events/id pill])))]
      [:<>
       (if (not (seq data))
         [no-result true]
         (cond
           (= selected-tab :graph)
           [force-directed-graph data-graph node-click-fn selected-nodes]
           :else
           [table-list "authors-table" data {:score-fn identity
                                             :sort-fn :idx
                                             :title-fn title-fn}])
         )])))

(defn- controls
  []
  [:span
   {:class (bem/be :authors :search-author)
    :on-click #(rf/dispatch [::events/set-show-author-search? (not @(rf/subscribe [::events/show-author-search?]))])}
   [tooltip-wrapper "Search for author by name" [:button
                                                 {:class [(bem/bem :authors :search-author (when @(rf/subscribe [::events/show-author-search?]) "active")) (bem/bm :button [:light :small])]}
                                                 [svg :common :search]]] 
   nbsp
   nbsp])

(defn view
  [id title]
  (let [state @(rf/subscribe [::events/state])
        loading? (= :loading (:state state))
        done? @(rf/subscribe [::events/done?])
        data @(rf/subscribe [::events/data])
        data-graph @(rf/subscribe [::events/data-graph])
        default-tab :list
        selected-tab @(rf/subscribe [::wevents/selection id ::display])
        selected-tab (if (not selected-tab)
                       default-tab
                       selected-tab)
        export-options (-> (wdb/get-widget-options-by-id id)
                           :export-counts)
        export-count @(rf/subscribe [::wevents/get-export-count id])
        user @(rf/subscribe [::app-events/user])
        show-search? @(rf/subscribe [::events/show-author-search?])]
    [widget-base/view id [title-with-filter title id] [widget-content id data data-graph selected-tab]
     (when show-search?
       [widget-header done? (:state state)])
     nil
     {:csv-event (if-not (restricted-role? user)
                   [::events/export export-count]
                   nil)
      :export-counts export-options
      :export-image? true
      :controls [controls]
      :selections
      [{:id ::display
        :type :tabs
        :default-option default-tab
        :options [{:id :graph :label [fa-icon :circle-nodes] :tooltip "Co-author network"}
                  {:id :list :label [fa-icon :list] :tooltip "Author list by influence score"}]}]}
     {:loading? loading?}]))